export const backgroundContainerClass = 'background-container';
export const menuBarClass = 'menu-bar';
